import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnApproved,
  columnDenied,
  columnTotal,
  columnTotalTransfers,
} from '@/constants/fields';
import UnsortedColumn from '@/components/table/UnsortedColumn';

const DatasetMetricsHeaderRow = () => (
  <Table.Row>
    <UnsortedColumn columnId={columnTotal} textAlign="right" />
    <UnsortedColumn columnId={columnApproved} textAlign="right" />
    <UnsortedColumn columnId={columnDenied} textAlign="right" />
    <UnsortedColumn columnId={columnTotalTransfers} textAlign="right" />
  </Table.Row>
);

export default DatasetMetricsHeaderRow;
